var path = 'app/scripts/modules/cloudfoundry/serverGroup/configure/wizard/envs.html';
var html = "<form name=\"form\" class=\"container-fluid form-horizontal\" ng-controller=\"cfServerGroupEnvsCtrl as envsCtrl\" novalidate>\n  <div class=\"modal-body\">\n    <cf-server-group-envs-selector command=\"command\" application=\"application\"></cf-server-group-envs-selector>\n  </div>\n</form>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/cloudfoundry/serverGroup/configure/wizard/envs.html
// module id = 1652
// module chunks = 0